import { useState, useMemo } from 'react';

export interface TicketFilters {
  status: string[];
  priority: string[];
  trade: string[];
  planLevel: string[];
  assigned: string[];
}

export const useTicketFilters = (tickets: any[], plans: any[]) => {
  const [filters, setFilters] = useState<TicketFilters>({
    status: [],
    priority: [],
    trade: [],
    planLevel: [],
    assigned: []
  });

  const updateFilter = (field: keyof TicketFilters, value: string, checked: boolean) => {
    setFilters(prev => {
      const current = prev[field];
      const nextValues = checked
        ? current.includes(value) ? current : [...current, value]
        : current.filter(item => item !== value);
      return { ...prev, [field]: nextValues };
    });
  };

  const resetFilters = () => {
    setFilters({
      status: [],
      priority: [],
      trade: [],
      planLevel: [],
      assigned: []
    });
  };

  const filteredTickets = useMemo(() => {
    let filtered = [...tickets];
    
    if (filters.status.length > 0) {
      filtered = filtered.filter(ticket => ticket.statusId != null && filters.status.includes(ticket.statusId));
    }
    
    if (filters.priority.length > 0) {
      filtered = filtered.filter(ticket => {
        const ticketPriorityId = ticket.priorityId || '';
        return ticketPriorityId !== '' && filters.priority.includes(ticketPriorityId);
      });
    }
    
    if (filters.trade.length > 0) {
      filtered = filtered.filter(ticket => {
        const ticketTradeId = ticket.gewerkId || '';
        return ticketTradeId !== '' && filters.trade.includes(ticketTradeId);
      });
    }
    
    if (filters.planLevel.length > 0 && plans) {
      filtered = filtered.filter(ticket => {
        if (!ticket.planLocation?.planId) return false;
        return filters.planLevel.includes(ticket.planLocation.planId);
      });
    }
    
    if (filters.assigned.length > 0) {
      filtered = filtered.filter(ticket => {
        const assignedUserId = ticket.assignedContractorId || ticket.assignedTo || '';
        return filters.assigned.includes(assignedUserId);
      });
    }
    
    return filtered;
  }, [tickets, filters, plans]);

  return {
    filters,
    updateFilter,
    resetFilters,
    filteredTickets
  };
};
